module.exports = __webpack_public_path__ + "images/emoji/new_moon.d69401feeaaa60d093bc.png";